import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Generic file SVG
 */
function FileSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 31"
			className={classnames('roc-icon roc-icon-file', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					d="M20.4374531,30.7499911 C21.9901837,30.7499911 23.2499464,29.4902284 23.2499464,27.9374978 L23.2499464,8.4785827 C23.2499464,7.7344324 22.9511418,7.0137424 22.4237993,6.4863999 L17.5077725,1.5703731 C16.9804301,1.0430306 16.2655766,0.7442261 15.5214263,0.7442261 L3.5624933,0.7442261 C2.0097626,0.7500626 0.75,2.0098252 0.75,3.5625559 L0.75,27.9374978 C0.75,29.4902284 2.0097626,30.7499911 3.5624933,30.7499911 L20.4374531,30.7499911 Z M20.4374531,27.9374978 L3.5624933,27.9374978 L3.5624933,3.5625559 L12.9374709,3.5625559 L12.9374709,9.6562914 C12.9374709,10.4355749 13.564434,11.062538 14.3437176,11.062538 L20.4374531,11.062538 L20.4374531,27.9374978 Z M20.2089151,8.2500447 L15.7499642,8.2500447 L15.7499642,3.7910938 L20.2089151,8.2500447 Z"
					fillRule="nonzero"
				></path>
			</g>
		</svg>
	);
}

export default FileSVG;
